/* eslint-disable */
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import "../../styles/admin_user_nav.css";
import { approvalUserRequest, approveUser, getAllRoles, getRoleDetailById, getSingleApprovalDetails, getSupervisorDetailById } from "../actions/userAction";



const defaultUser = {
  email: "",
  mobile: "",
  roleId: "",
  isActive: true,
  lastName: "",
  password: "",
  roleName: "",
  username: "",
  firstName: "",
  departmentId: 1,
  departmentName: "",
  supervisorName: ""
};



const ApprovalUser = (props) => {
    const { register, handleSubmit, formState, watch } = useForm({
        mode: "onChange"
    });
        const [user, setUser] = useState(defaultUser);
        const [status, setStatus] = useState('');
        const [comments, setComments] = useState('');
        const dispatch = useDispatch();

        let { roleByDept, supervisorByRole ,singleApprovalDetails,singleUserRoleDetail,singleSupervisorDetail} = useSelector((state) => state.userManagementReducer, shallowEqual);

        const userDetailString = singleApprovalDetails && (singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.entityApprovalDto?.detail)        
        useEffect(() => {
          if (props.showModal) {
            const userDetailString =
              singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.entityApprovalDto?.detail;
        
            if (userDetailString) {
              try {
                const parsedData = JSON.parse(userDetailString);
        
                if (JSON.stringify(parsedData) !== JSON.stringify(user)) {
                  setUser(prev => ({
                    ...prev,
                    ...parsedData
                  }));
                }
              } catch (err) {
                console.error("Invalid JSON:", err);
              }
            }
          }

          if(userDetailString){
              dispatch(getSupervisorDetailById(2))
              dispatch(getRoleDetailById (2))
          }
          dispatch(getAllRoles())
        }, [singleApprovalDetails, props.showModal]);



    const onSubmit = (singleApprovalDetails) => {
        if(singleApprovalDetails){
            singleApprovalDetails.entityApprovalDto.entityApprovalAction.action  = status;
             singleApprovalDetails.entityApprovalDto.entityApprovalAction.comment = comments;
        }
        props.setShowModal(false)
       dispatch(approveUser(singleApprovalDetails))
    }
     let userDepartment = []
     userDepartment = roleByDept && roleByDept.filter((ele)=> ele.id == user.departmentId )

    return (
        <Modal size="xl" show={props.showModal} onHide={() => { props.setShowModal(false) }} aria-labelledby="example-modal-sizes-title-xl" backdrop="static">
            <form >
                <Modal.Header className="logout_heading">
                    <Modal.Title className='logout_title'>
                    Approval 
                    </Modal.Title>
                       <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                       onClick={() => { props.setShowModal(false) }}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row col-md-12">
                        <div className="col-md-8">
                            <div className="row">
                                <div className="form-group col-md-2 mb-0">
                                <label className="LeftText"> <strong>First Name : </strong> </label>                                 
                                </div>
                                <div className="form-group col-md-4 mb-0">
                                   <label className="LeftText">{user.firstName}</label>
                                </div>
                                <div className="form-group col-md-2 mb-0">
                                    <label className="LeftText"> <strong>Last Name : </strong> </label>
                                </div>
                                <div className="form-group col-md-4 mb-0">
                                    <label className="LeftText">{user.lastName}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-2 mb-0">
                                    <label className="LeftText"> <strong>E-Mail ID : </strong> </label>
                                </div>
                                <div className="form-group col-md-4 mb-0">
                                    <label className="LeftText">{user.email}</label>
                                </div>
                                <div className="form-group col-md-2 mb-0">
                                    <label className="LeftText"> <strong>Mobile Number : </strong> </label>
                                </div>
                                <div className="form-group col-md-4 mb-0">
                                    <label className="LeftText">{user.mobile}</label>
                                </div>
                            </div>
                            <hr></hr>
                            <div style={{ height: "200px", overflowY: "auto", overflowX: "hidden" }}>
                                <div className="card" style={{ marginTop: "30px" }}>
                                    <div className="card-header" style={{ height: "40px", paddingTop: "0px" }}>
                                        <div className="row" style={{ paddingTop: "0px" }}>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText"> <strong>  Department </strong> </label>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText"> <strong>Role</strong> </label>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <label className="LeftText"> <strong>Supervisor</strong> </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body" style={{ paddingTop: "0.5rem" }}>
                                        <div className="row" style={{ marginTop: "1rem" }}>
                                            <div className="form-group col-md-4 mb-0">
                                                <label>{userDepartment[0]?.name}</label>
                                            </div>
                                            <div className="form-group col-md-4 mb-0">
                                                <label>{singleUserRoleDetail.name}</label>
                                            </div>
                                            <div className="form-group col-md-3 mb-0">
                                                <label>{singleSupervisorDetail.firstName + " " + singleSupervisorDetail.lastName}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                         <div className="card p-3 col-md-4">
      <h6 className="mb-3">Approval:</h6>

      <div className="form-group mb-3">
        <strong>Action</strong><br />
        <label className="form-label"> <strong>Status : </strong> { singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.action ==1 ? "Approved" : singleApprovalDetails?.entityApprovalDto?.entityApprovalAction?.action == 2 ?"Rejected" :"Pending" }<span className="text-danger">*</span></label>
        <div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="status"
              id="approve"
              value="1"
              checked={status === '1'}
              onChange={(e) => setStatus(e.target.value)}
              required
            />
            <label className="form-check-label" htmlFor="approve">Approve</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="status"
              id="reject"
              value="2"
              checked={status === '2'}
              onChange={(e) => setStatus(e.target.value)}
            />
            <label className="form-check-label" htmlFor="reject">Reject</label>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="comments">Comments</label>
        <textarea
          id="comments"
          className="form-control"
          rows="3"
          placeholder="Enter text up to 255 characters"
          maxLength="255"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </div>
    </div>
                        {/* <div className="col-md-4">
                            <div className="card">
                                <div className="card-header">
                                   Approval ({props.setSelectedApprovalUser && props.setSelectedApprovalUser.userOasApproval.status})
                                </div>
                                <div className={`card-body ${props.setSelectedApprovalUser && props.setSelectedApprovalUser.userOasApproval.status=='Published'?"disabled-link":""}`}>
                                 <label style={{fontWeight:'bold'}}>Action</label>&nbsp;&nbsp;<h6>{props.setSelectedApprovalUser && props.setSelectedApprovalUser.userOasApproval.approvalType}</h6><br />
                                    <h6  style={{fontWeight:'bold'}}>Status<span className="redColor">*</span></h6>
                                    <div className="col-md-12" style={{marginLeft: '14px', paddingTop:'7px'}}>
                                        <label style={{ position: "relative",  right: "30px", marginRight: "10px" }}>
                                            <input type="radio" className="radio" name="statustype" value="Accept" ref={register({ required: true })} />&nbsp;Approve
                                        </label>
                                        <label style={{ position: "relative",  right: "30px", marginRight: "10px" }}>
                                            <input type="radio" className="radio" name="statustype" value="Reject" ref={register({ required: true })} />&nbsp;Reject
                                        </label>
                                    </div>
                                    { watch("statustype") == "Reject" ?  
                                    <>
                                        <h6  style={{fontWeight:'bold'}}>Comments<span className="redColor">*</span></h6>
                                            <div style={{ paddingTop:'10px'}}>
                                                <h6> 
                                                    <input
                                                    type="text"
                                                    className="form-control"
                                                    name="comment"
                                                    maxLength={255}
                                                    placeholder={docLabels.ENTER_TEXT_UPTO_255_CHARACTERS}
                                                    ref={register({ required: true,  pattern: {
                                                        value: /^(?!\s+$)/
                                                    }})}
                                                    />
                                                </h6>
                                            </div>
                                    </> : 
                                    <>
                                        <div style={{ paddingTop:'10px'}}>
                                            <h6  style={{fontWeight:'bold'}}>Comments</h6>
                                                <h6> 
                                                    <input
                                                    type="text"
                                                    className="form-control"
                                                    name="comment"
                                                    maxLength={255}
                                                    placeholder={docLabels.ENTER_TEXT_UPTO_255_CHARACTERS}
                                                    ref={register({ required: false ,  pattern: {
                                                        value: /^(?!\s+$)/
                                                    }})}
                                                    />
                                                </h6>
                                        </div>
                                    </> }
                                </div>

                            </div>
                        </div> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" type="button" onClick={() => { props.setShowModal(false) }}>Cancel</button>
                    <button className=" btn btn-primary custom_button   " disabled={!formState.isValid} onClick={handleSubmit((e) => { onSubmit(e,singleApprovalDetails) })}>Save</button>
                </Modal.Footer>
            </form>
        </Modal >
    )
}
export default ApprovalUser